<div id="monthendTitle" class="col s12">
    <div class="dashboard-flip-status-box-wrap">
      <!-- <div class="firstSection">
        <div class="row">
          <div class="col m12">
            <div class="white-box">
              <div class="card-heading">
                <span>Critical Idea Status</span>
              </div>
              <div class="row" style="overflow-x: scroll;width: 100%; margin: 0 auto; white-space : nowrap;">
  
                <div class="pr-4" style="width: 20%;display: inline-block;padding-right: 10px;" *ngFor="let item of criticalActivityList">
                  <div class="flip-card flip-card-col-border">
                    <div class="flip-card-inner" [ngClass]=item.class>
                      <div class="flip-card-front">
                        <p class="card-data s-count">{{item.percentage}}%</p>
                        <p class="card-title s-count"> {{item.name}}</p>
                      </div>
                      <div class="flip-card-back ">
                        <p class="card-title-back f-count">{{item.name}}</p>
                        <p class="card-data-back f-count">{{item.value}}</p>
                      </div>
                    </div>
                  </div>                
  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
  
      <div class="status-box-wrap">
        <div class="row">
          <div class="col m12">
            <div class="white-box gray-white-box">
              <div class="card-heading">
                <span>Overall Idea Status</span>
              </div>
            </div>
            <div class="status-box-white-wrap">
              
              <div class="row" style="overflow-x: scroll;width: 100%; margin: 0 auto; white-space : nowrap;">
              <div *ngFor="let item of overallActivityList" style="width: 20%;display: inline-block;padding-right: 10px;" class="status-box-white">
                <div class="status-box-content" [ngClass]=item.class (click)="getTabularData(item)">
                  
                  <div class="row" style="margin-bottom: 0px;">
                    
                    <div class="col s6">
                      <h6 class="first-count">{{item.value}}</h6>
                      <h6 class="second-count">{{item.percentage}}%</h6>
                    </div>
                    <div class="col s6">
                    </div>
                    <div class="col s12" style="margin-top: 20px;">
                      <p>{{item.name}}</p>
                    </div>
                  </div>
                  
                </div>
              </div>
  
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>